<template>
  <div>
    <div class="min-vh-100">
      <CRow class="no-gutters px-3 px-sm-0">
        <b-col sm="6" class="text-center text-sm-left mb-3 mb-sm-0">
          <h1 class="mr-sm-4 header-main text-uppercase">ข้อมูล Detail</h1>
        </b-col>
      </CRow>

      <div class="mt-3 bg-white-border p-3">
        <b-row v-if="isLoadingData">
          <b-col class="px-4 px-sm-5 py-4 vh-100">
            <img src="/img/loading.svg" class="loading" alt="loading" />
          </b-col>
        </b-row>
        <div>
          <b-row>
            <b-col md="6">
              <InputText
                textFloat="Name"
                placeholder="Name"
                type="text"
                name="Name"
                isRequired
                v-model="form.name"
                :isValidate="$v.form.name.$error"
                :v="$v.form.name"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <textarea rows="30" cols="100" name="nname" id="nname" v-model="form.prompt" />
            </b-col>
          </b-row>

          <b-row class="mt-5">
            <b-col md="6">
              <b-button
                :disabled="isDisable"
                @click="cancleHandler"
                class="btn-details-set btn-cancel"
                >CANCEL</b-button
              >
            </b-col>
            <b-col md="6" class="text-sm-right">
              <button
                type="button"
                @click="checkForm()"
                :disabled="isDisable"
                class="btn btn-main btn-details-set ml-md-2 text-uppercase"
              >
                SAVE
              </button>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
    <ModalAlert
      ref="modalAlert"
      :text="modalMessage"
      v-on:hadleModalAlertClose="hadleModalAlertClose"
    />
    <ModalAlertError ref="modalAlertError" :text="modalMessage" />
    <ModalLoading ref="modalLoading" :hasClose="false" />
  </div>
</template>

<script>
import {
  required,
  integer,
  minLength,
  requiredIf,
  email,
  helpers,
  alphaNum
} from "vuelidate/lib/validators";

const password = helpers.regex(
  "password",
  /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9!-_]+)$/
);

const alpha = helpers.regex("alpha", /^[\u0E00-\u0E7Fa-zA-Z']*$/);

import InputText from "@/components/inputs/InputText";
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import ModalLoading from "@/components/modal/alert/ModalLoading";
export default {
  components: {
    InputText,
    ModalAlert,
    ModalAlertError,
    ModalLoading
  },
  data() {
    return {
      isLoadingData: false,
      modalMessage: "",
      isDisable: false,
      id: this.$route.params.id,
      redirecId: 0,
      form: {
        id: 0,
        name: "",
        prompt: ""
      }
    };
  },
  validations: {
    form: {
      name: { required }
    }
  },
  created: async function () {
    this.getDatas();
  },
  methods: {
    isAlphabet: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 65 && charCode < 91) {
        return true;
      } else if (charCode > 96 && charCode < 123) {
        return true;
      } else if (charCode > 160 && charCode < 238) {
        return true;
      } else {
        evt.preventDefault();
      }
    },
    hadleModalAlertClose() {
      this.$router.push({
        path: `/prompt-template`
      });
    },
    cancleHandler() {
        this.$router.push({
        path: `/prompt-template`
      });
    },
    getDatas: async function () {
      if (this.id !== "0") {
        this.isLoadingData = true;
        await this.axios
          .get(`${this.$baseUrl}/promptTemplate/${this.id}`)
          .then(res => {
            if (res.data.result == 1) {
              this.form = { ...this.form, ...res.data.detail };
              this.isLoadingData = false;
            }
          });
      } else {
      }
    },
    checkForm: async function () {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        return;
      }

      this.submit();
    },
    submit: async function () {
      this.isDisable = true;
      this.$refs.modalLoading.show();
      await this.axios
        .post(`${this.$baseUrl}/promptTemplate`, this.form)
        .then(res => {
          if (res.data.result == 1) {
            this.redirecId = res.data.detail.id;
            this.modalMessage = "สำเร็จ";
            this.$refs.modalLoading.hide();
            this.$refs.modalAlert.show();
          } else {
            this.modalMessage = res.data.message;
            this.$refs.modalLoading.hide();
            this.$refs.modalAlertError.show();
          }
          this.isDisable = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-reset-password {
  background-color: #7160c4;
  color: white;
}
</style>
